import { useSyncAuthenticatedUserToDataStore } from './hooks/useSyncAuthenticatedUserToDataStore'

export function AuthenticatedUserSync() {
  useSyncAuthenticatedUserToDataStore()
  // eslint-disable-next-line unicorn/no-null
  return null
}
